import { useState } from "react";
import { motion } from "framer-motion";

const PINS = [
  { name: "Loxahatchee", x: 26, y: 36 },
  { name: "Loxahatchee Groves", x: 47, y: 42 },
  { name: "Westlake", x: 46, y: 22 },
  { name: "Royal Palm Beach", x: 70, y: 34 },
  { name: "Arden", x: 22, y: 58 },
  { name: "Wellington", x: 68, y: 66 },
];

export const ServiceAreaMap = ({ active: activeProp, onSelect }) => {
  const [hover, setHover] = useState(null);
  const active = hover || activeProp;
  return (
    <figure data-testid="service-area-map" className="relative overflow-hidden rounded-[4px] bg-[#14263D] p-4 text-white md:p-6">
      <svg viewBox="0 0 100 80" className="h-auto w-full" role="img" aria-label="Illustrative map of First Due service areas in western Palm Beach County">
        <defs>
          <pattern id="grid" width="5" height="5" patternUnits="userSpaceOnUse">
            <path d="M5 0 H0 V5" fill="none" stroke="rgba(255,255,255,0.06)" strokeWidth="0.2" />
          </pattern>
        </defs>
        <rect width="100" height="80" fill="url(#grid)" />
        <path d="M8 12 C20 6 50 8 70 14 C84 18 92 30 90 46 C88 62 80 74 60 76 C40 78 18 74 10 60 C4 48 2 22 8 12 Z" fill="rgba(255,255,255,0.04)" stroke="rgba(255,255,255,0.25)" strokeWidth="0.3" strokeDasharray="1 1" />
        <path d="M0 48 C25 47 50 50 100 48" stroke="rgba(255,255,255,0.35)" strokeWidth="0.6" fill="none" />
        <text x="3" y="46.5" fontSize="2" fill="rgba(255,255,255,0.7)" fontFamily="JetBrains Mono">SOUTHERN BLVD</text>
        <path d="M58 0 C60 30 62 50 60 80" stroke="rgba(255,255,255,0.18)" strokeWidth="0.4" fill="none" />
        <text x="86" y="44" fontSize="2" fill="rgba(255,255,255,0.7)" fontFamily="JetBrains Mono">EAST →</text>
        <text x="94" y="8" fontSize="3" fill="rgba(255,255,255,0.7)" fontFamily="JetBrains Mono" textAnchor="middle">N</text>
        <path d="M94 9.5 L94 14" stroke="rgba(255,255,255,0.7)" strokeWidth="0.3" />
        {PINS.map((p, i) => {
          const on = active === p.name;
          return (
            <g
              key={p.name}
              data-testid={`map-pin-${p.name.toLowerCase().replace(/\s/g, "-")}`}
              onMouseEnter={() => setHover(p.name)}
              onMouseLeave={() => setHover(null)}
              onClick={() => onSelect?.(p.name)}
              className="cursor-pointer"
            >
              <motion.circle
                cx={p.x} cy={p.y} r={on ? 9 : 6.5}
                fill="#A52A32" fillOpacity={on ? 0.35 : 0.18}
                initial={{ scale: 0 }} whileInView={{ scale: 1 }} viewport={{ once: true }}
                transition={{ delay: 0.2 + i * 0.12, duration: 0.8 }}
                style={{ transformOrigin: `${p.x}px ${p.y}px`, transition: "r 0.3s" }}
              />
              <circle cx={p.x} cy={p.y} r="1.4" fill={on ? "#fff" : "#f0b3b7"} />
              <text x={p.x} y={p.y - 3} fontSize="2.8" textAnchor="middle" fill="#fff" fontFamily="Cormorant Garamond" fontWeight="600">{p.name}</text>
            </g>
          );
        })}
      </svg>
      <figcaption className="mt-3 flex flex-wrap justify-between gap-2 font-mono text-[0.7rem] uppercase tracking-[0.16em] text-white/75">
        <span>Western Palm Beach County</span>
        <span>Illustrative, not to scale</span>
      </figcaption>
    </figure>
  );
};
